<template>
  <div>
    <input-labelled v-if="phoneInputLabelled"
                    :type="'tel'"
                    :label="phoneInputName"
                    :value="phone"
                    :error="state.phoneError"
                    @input="phoneChanged"
                    @click="phoneClicked"></input-labelled>
    <input-align-left v-else
                      :type="'tel'"
                      :placeholder="phoneInputName"
                      :value="phone"
                      :error="state.phoneError"
                      :transparent="inputTransparent"
                      @input="phoneChanged"
                      @click="phoneClicked"></input-align-left>

    <geetest></geetest>

    <div class="control is-grouped login-verify__control-group">
      <input-align-left :type="'tel'"
                        :placeholder="'验证码'"
                        :value="smsVerifCode"
                        :error="state.smsVerifCodeError"
                        :transparent="inputTransparent"
                        @input="smsVerifCodeChanged"
                        @click="smsVerifCodeClicked"></input-align-left>
      <p class="control login-verify__sms-button" :class="{ 'login-verify__sms-button--primary': !inputTransparent }">
        <a class="button" :class="smsRqstButtonClass" @click="smsButtonClicked('sms')">
          获取验证码
          <template v-if="smsTime > 0">
            ({{ smsTimeDisplay }})
          </template>
        </a>
      </p>
      <span class="help has-text-right login-verify__help">
        收不到验证码？点此接收
        <a :class="smsRqstButtonClass" @click="smsButtonClicked('voice')">语音验证</a>
      </span>
    </div>
  </div>
</template>

<style lang="stylus" scoped>
  @import '../../styles/index.styl'
  left-width = siz(165)
  right-width = siz(125)
  left-right-padding = login-width - left-width - right-width
  .login-verify__control-group
    flex-wrap: wrap
    .lxm-login-input
      width: left-width
    &.control.is-grouped > .control:not(:last-child)
      margin-right: siz(8.5)
  .login-verify__image
    width: right-width
    height: login-control-height
    border-radius: login-radius
  .login-verify__sms-button
      margin-right: 0 !important
      login-verify-button()
    .button
      width: right-width
  .login-verify__sms-button--primary
    .button
      color: white
      background-color: login-primary
    .button:hover
      color: white
  .login-verify__help
    color: grey
    login-group-input-help()
</style>

<script>
  import Geetest from './Geetest.vue'
  import InputLabelled from './InputLabelled.vue'
  import InputAlignLeft from './InputAlignLeft.vue'
  import * as aTypes from '../../../store/action-types'
  import * as mTypes from '../../../store/mutation-types'
  export default {
    components: {
      Geetest,
      InputLabelled,
      InputAlignLeft
    },
    props: {
      phoneInputName: {
        type: String,
        default: '手机'
      },
      phoneInputLabelled: {
        type: Boolean,
        default: false
      },
      inputTransparent: {
        type: Boolean,
        default: true
      },
      smsTime: {
        type: Number,
        default: 0
      }
    },
    computed: {
      state () {
        return this.$store.state.login
      },
      phone () {
        return this.$store.state.login.phone
      },
      robotVerifCode () {
        return this.$store.state.login.robotVerifCode
      },
      smsVerifCode () {
        return this.$store.state.login.smsVerifCode
      },
      ableToRequestSms () {
        return this.smsTime === 0 && this.validate // && !this.state.robotVerifCodeError
      },
      buttonLoading () {
        return this.$store.state.loading[aTypes.LOGIN_RQST_SMS_VALIDATION]
      },
      smsTimeDisplay () {
        return Math.floor(this.smsTime / 1000)
      },
      smsRqstButtonClass () {
        return {
          'is-disabled': !this.ableToRequestSms,
          'is-loading': this.buttonLoading
        }
      },
      validate () {
        return this.$store.state.geetest.validate
      }
    },
    mounted () {
      this.$store.commit(mTypes.LOGIN_CLEAR_VERIF_CODE)
    },
    methods: {
      phoneChanged (e) {
        this.$store.commit(mTypes.LOGIN_UPDATE, { phone: e.target.value })
      },
      phoneClicked (e) {
        this.$store.commit(mTypes.LOGIN_UPDATE, { phoneError: '' })
      },
      robotVerifCodeChanged (e) {
        this.$store.commit(mTypes.LOGIN_UPDATE, { robotVerifCodeError: '', robotVerifCode: e.target.value })
      },
      robotVerifCodeSubmit () {
        this.$store.dispatch(aTypes.LOGIN_SUBMIT_ROBOT_VERIF_CODE, this.robotVerifCode)
      },
      robotVerifCodeClicked () {
        this.$store.commit(mTypes.LOGIN_UPDATE, { robotVerifCodeError: '' })
      },
      reloadRobotVerifCodeImage () {
        this.$store.commit(mTypes.LOGIN_REFRESH_CAPTCHA)
        this.$store.commit(mTypes.LOGIN_UPDATE, { robotVerifCode: '', robotVerifCodeError: '' })
        this.$refs.inputRobotVerifCode.focus()
      },
      smsVerifCodeChanged (e) {
        this.$store.commit(mTypes.LOGIN_UPDATE, { smsVerifCode: e.target.value })
      },
      smsVerifCodeClicked (e) {
        this.$store.commit(mTypes.LOGIN_UPDATE, { smsVerifCodeError: '' })
      },
      smsButtonClicked (smsType) {
        if (this.ableToRequestSms && !this.buttonLoading) {
          this.$emit('rqst-sms', {
            phone: this.phone,
            code: this.validate || this.robotVerifCode,
            smsType: smsType
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// PhoneVerification.vue?9285becc